// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ErrorResponse } from '../models';
import { InlineObject1 } from '../models';
import { InlineObject2 } from '../models';
import { LearningRequest } from '../models';
import { LearningRequestChangeStatus } from '../models';
import { LearningRequestCreate } from '../models';
import { LearningRequestEdit } from '../models';
import { LearningRequestList } from '../models';
import { LearningRequestShortList } from '../models';
import { LearningRequestStatistic } from '../models';
import { PracticePass } from '../models';
import { TestPassResult } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * LearningRequestApi - axios parameter creator
 * @export
 */
export const LearningRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Delete learning request.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/learning-request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Change LearningRequest formedAt.
         * @param {string} id 
         * @param {InlineObject1} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFormedAt(id: string, body?: InlineObject1, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling changeFormedAt.');
            }
            const localVarPath = `/v1/learning-request/{id}/formedAt`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Change LearningRequest startedAt.
         * @param {string} id 
         * @param {InlineObject2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStartedAt(id: string, body?: InlineObject2, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling changeStartedAt.');
            }
            const localVarPath = `/v1/learning-request/{id}/startedAt`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Change status of learning request.
         * @param {string} id 
         * @param {LearningRequestChangeStatus} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatus(id: string, body?: LearningRequestChangeStatus, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling changeStatus.');
            }
            const localVarPath = `/v1/learning-request/{id}/change-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get results of course lecture test.
         * @param {string} id 
         * @param {string} lectureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseLectureTestResults(id: string, lectureId: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling courseLectureTestResults.');
            }
            // verify required parameter 'lectureId' is not null or undefined
            if (lectureId === null || lectureId === undefined) {
                throw new RequiredError('lectureId','Required parameter lectureId was null or undefined when calling courseLectureTestResults.');
            }
            const localVarPath = `/v1/learning-request/{id}/results/course/lecture/{lectureId}/test`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lectureId"}}`, encodeURIComponent(String(lectureId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get results of course practice.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursePracticeResult(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling coursePracticeResult.');
            }
            const localVarPath = `/v1/learning-request/{id}/results/course/practice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get results of course test.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseTestResults(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling courseTestResults.');
            }
            const localVarPath = `/v1/learning-request/{id}/results/course/test`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `company.owner` or `company.learning_request_manager`
         * @summary Create new learning request.
         * @param {LearningRequestCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: LearningRequestCreate, options: any = {}): RequestArgs {
            const localVarPath = `/v1/learning-request`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Edit learning request.
         * @param {string} id 
         * @param {LearningRequestEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: LearningRequestEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/learning-request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`
         * @summary Get single learning request.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/learning-request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`
         * @summary Get learning request statistic.
         * @param {string} companyId 
         * @param {string} [responsibleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningRequestStatistic(companyId: string, responsibleId?: string, options: any = {}): RequestArgs {
            // verify required parameter 'companyId' is not null or undefined
            if (companyId === null || companyId === undefined) {
                throw new RequiredError('companyId','Required parameter companyId was null or undefined when calling getLearningRequestStatistic.');
            }
            const localVarPath = `/v1/learning-requests/statistic`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (responsibleId !== undefined) {
                localVarQueryParameter['responsibleId'] = responsibleId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Handle learning request.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handle(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling handle.');
            }
            const localVarPath = `/v1/learning-request/{id}/handle`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find learning requests to filter.
         * @param {string} [number] 
         * @param {string} [companyId] 
         * @param {string} [responsibleId] 
         * @param {string} [courseId] 
         * @param {string} [courseTitle] 
         * @param {string} [categoryId] 
         * @param {string} [contractorId] 
         * @param {'juridical' | 'physical'} [contractorType] 
         * @param {string} [clientType] 
         * @param {string} [clientId] 
         * @param {string} [resourceType] 
         * @param {string} [resourceId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled'} [status] 
         * @param {Date} [formedAtMin] 
         * @param {Date} [formedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'createdAt' | 'updatedAt' | 'formedAt' | 'number'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(number?: string, companyId?: string, responsibleId?: string, courseId?: string, courseTitle?: string, categoryId?: string, contractorId?: string, contractorType?: 'juridical' | 'physical', clientType?: string, clientId?: string, resourceType?: string, resourceId?: string, priceMin?: number, priceMax?: number, status?: 'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled', formedAtMin?: Date, formedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, sort?: 'createdAt' | 'updatedAt' | 'formedAt' | 'number', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/v1/learning-requests`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (number !== undefined) {
                localVarQueryParameter['number'] = number;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (responsibleId !== undefined) {
                localVarQueryParameter['responsibleId'] = responsibleId;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (courseTitle !== undefined) {
                localVarQueryParameter['courseTitle'] = courseTitle;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (contractorId !== undefined) {
                localVarQueryParameter['contractorId'] = contractorId;
            }

            if (contractorType !== undefined) {
                localVarQueryParameter['contractorType'] = contractorType;
            }

            if (clientType !== undefined) {
                localVarQueryParameter['clientType'] = clientType;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (formedAtMin !== undefined) {
                localVarQueryParameter['formedAtMin'] = (formedAtMin as any).toISOString();
            }

            if (formedAtMax !== undefined) {
                localVarQueryParameter['formedAtMax'] = (formedAtMax as any).toISOString();
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find learning requests short by filter.
         * @param {string} [number] 
         * @param {string} [companyId] 
         * @param {string} [responsibleId] 
         * @param {string} [courseId] 
         * @param {string} [courseTitle] 
         * @param {string} [categoryId] 
         * @param {string} [contractorId] 
         * @param {'juridical' | 'physical'} [contractorType] 
         * @param {string} [clientType] 
         * @param {string} [clientId] 
         * @param {string} [resourceType] 
         * @param {string} [resourceId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled'} [status] 
         * @param {Date} [formedAtMin] 
         * @param {Date} [formedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'createdAt' | 'updatedAt' | 'formedAt' | 'number'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShort(number?: string, companyId?: string, responsibleId?: string, courseId?: string, courseTitle?: string, categoryId?: string, contractorId?: string, contractorType?: 'juridical' | 'physical', clientType?: string, clientId?: string, resourceType?: string, resourceId?: string, priceMin?: number, priceMax?: number, status?: 'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled', formedAtMin?: Date, formedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, sort?: 'createdAt' | 'updatedAt' | 'formedAt' | 'number', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/v1/learning-requests/short`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (number !== undefined) {
                localVarQueryParameter['number'] = number;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (responsibleId !== undefined) {
                localVarQueryParameter['responsibleId'] = responsibleId;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (courseTitle !== undefined) {
                localVarQueryParameter['courseTitle'] = courseTitle;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (contractorId !== undefined) {
                localVarQueryParameter['contractorId'] = contractorId;
            }

            if (contractorType !== undefined) {
                localVarQueryParameter['contractorType'] = contractorType;
            }

            if (clientType !== undefined) {
                localVarQueryParameter['clientType'] = clientType;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['clientId'] = clientId;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (formedAtMin !== undefined) {
                localVarQueryParameter['formedAtMin'] = (formedAtMin as any).toISOString();
            }

            if (formedAtMax !== undefined) {
                localVarQueryParameter['formedAtMax'] = (formedAtMax as any).toISOString();
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LearningRequestApi - functional programming interface
 * @export
 */
export const LearningRequestApiFp = function(configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Delete learning request.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration)._delete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Change LearningRequest formedAt.
         * @param {string} id 
         * @param {InlineObject1} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFormedAt(id: string, body?: InlineObject1, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).changeFormedAt(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Change LearningRequest startedAt.
         * @param {string} id 
         * @param {InlineObject2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStartedAt(id: string, body?: InlineObject2, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).changeStartedAt(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Change status of learning request.
         * @param {string} id 
         * @param {LearningRequestChangeStatus} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatus(id: string, body?: LearningRequestChangeStatus, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningRequest> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).changeStatus(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get results of course lecture test.
         * @param {string} id 
         * @param {string} lectureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseLectureTestResults(id: string, lectureId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestPassResult>> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).courseLectureTestResults(id, lectureId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get results of course practice.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursePracticeResult(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PracticePass>> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).coursePracticeResult(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get results of course test.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseTestResults(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestPassResult>> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).courseTestResults(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `company.owner` or `company.learning_request_manager`
         * @summary Create new learning request.
         * @param {LearningRequestCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: LearningRequestCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningRequest> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).create(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Edit learning request.
         * @param {string} id 
         * @param {LearningRequestEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: LearningRequestEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningRequest> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).edit(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`
         * @summary Get single learning request.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningRequest> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).get(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`
         * @summary Get learning request statistic.
         * @param {string} companyId 
         * @param {string} [responsibleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningRequestStatistic(companyId: string, responsibleId?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningRequestStatistic> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).getLearningRequestStatistic(companyId, responsibleId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Handle learning request.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handle(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningRequest> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).handle(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find learning requests to filter.
         * @param {string} [number] 
         * @param {string} [companyId] 
         * @param {string} [responsibleId] 
         * @param {string} [courseId] 
         * @param {string} [courseTitle] 
         * @param {string} [categoryId] 
         * @param {string} [contractorId] 
         * @param {'juridical' | 'physical'} [contractorType] 
         * @param {string} [clientType] 
         * @param {string} [clientId] 
         * @param {string} [resourceType] 
         * @param {string} [resourceId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled'} [status] 
         * @param {Date} [formedAtMin] 
         * @param {Date} [formedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'createdAt' | 'updatedAt' | 'formedAt' | 'number'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(number?: string, companyId?: string, responsibleId?: string, courseId?: string, courseTitle?: string, categoryId?: string, contractorId?: string, contractorType?: 'juridical' | 'physical', clientType?: string, clientId?: string, resourceType?: string, resourceId?: string, priceMin?: number, priceMax?: number, status?: 'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled', formedAtMin?: Date, formedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, sort?: 'createdAt' | 'updatedAt' | 'formedAt' | 'number', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningRequestList> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).list(number, companyId, responsibleId, courseId, courseTitle, categoryId, contractorId, contractorType, clientType, clientId, resourceType, resourceId, priceMin, priceMax, status, formedAtMin, formedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, sort, order, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find learning requests short by filter.
         * @param {string} [number] 
         * @param {string} [companyId] 
         * @param {string} [responsibleId] 
         * @param {string} [courseId] 
         * @param {string} [courseTitle] 
         * @param {string} [categoryId] 
         * @param {string} [contractorId] 
         * @param {'juridical' | 'physical'} [contractorType] 
         * @param {string} [clientType] 
         * @param {string} [clientId] 
         * @param {string} [resourceType] 
         * @param {string} [resourceId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled'} [status] 
         * @param {Date} [formedAtMin] 
         * @param {Date} [formedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'createdAt' | 'updatedAt' | 'formedAt' | 'number'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShort(number?: string, companyId?: string, responsibleId?: string, courseId?: string, courseTitle?: string, categoryId?: string, contractorId?: string, contractorType?: 'juridical' | 'physical', clientType?: string, clientId?: string, resourceType?: string, resourceId?: string, priceMin?: number, priceMax?: number, status?: 'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled', formedAtMin?: Date, formedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, sort?: 'createdAt' | 'updatedAt' | 'formedAt' | 'number', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningRequestShortList> {
            const localVarAxiosArgs = LearningRequestApiAxiosParamCreator(configuration).listShort(number, companyId, responsibleId, courseId, courseTitle, categoryId, contractorId, contractorType, clientType, clientId, resourceType, resourceId, priceMin, priceMax, status, formedAtMin, formedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, sort, order, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LearningRequestApi - factory interface
 * @export
 */
export const LearningRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Delete learning request.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any) {
            return LearningRequestApiFp(configuration)._delete(id, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Change LearningRequest formedAt.
         * @param {string} id 
         * @param {InlineObject1} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFormedAt(id: string, body?: InlineObject1, options?: any) {
            return LearningRequestApiFp(configuration).changeFormedAt(id, body, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Change LearningRequest startedAt.
         * @param {string} id 
         * @param {InlineObject2} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStartedAt(id: string, body?: InlineObject2, options?: any) {
            return LearningRequestApiFp(configuration).changeStartedAt(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Change status of learning request.
         * @param {string} id 
         * @param {LearningRequestChangeStatus} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatus(id: string, body?: LearningRequestChangeStatus, options?: any) {
            return LearningRequestApiFp(configuration).changeStatus(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get results of course lecture test.
         * @param {string} id 
         * @param {string} lectureId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseLectureTestResults(id: string, lectureId: string, options?: any) {
            return LearningRequestApiFp(configuration).courseLectureTestResults(id, lectureId, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get results of course practice.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursePracticeResult(id: string, options?: any) {
            return LearningRequestApiFp(configuration).coursePracticeResult(id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get results of course test.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseTestResults(id: string, options?: any) {
            return LearningRequestApiFp(configuration).courseTestResults(id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `company.owner` or `company.learning_request_manager`
         * @summary Create new learning request.
         * @param {LearningRequestCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: LearningRequestCreate, options?: any) {
            return LearningRequestApiFp(configuration).create(body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Edit learning request.
         * @param {string} id 
         * @param {LearningRequestEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: LearningRequestEdit, options?: any) {
            return LearningRequestApiFp(configuration).edit(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`
         * @summary Get single learning request.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any) {
            return LearningRequestApiFp(configuration).get(id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`
         * @summary Get learning request statistic.
         * @param {string} companyId 
         * @param {string} [responsibleId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningRequestStatistic(companyId: string, responsibleId?: string, options?: any) {
            return LearningRequestApiFp(configuration).getLearningRequestStatistic(companyId, responsibleId, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
         * @summary Handle learning request.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handle(id: string, options?: any) {
            return LearningRequestApiFp(configuration).handle(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Find learning requests to filter.
         * @param {string} [number] 
         * @param {string} [companyId] 
         * @param {string} [responsibleId] 
         * @param {string} [courseId] 
         * @param {string} [courseTitle] 
         * @param {string} [categoryId] 
         * @param {string} [contractorId] 
         * @param {'juridical' | 'physical'} [contractorType] 
         * @param {string} [clientType] 
         * @param {string} [clientId] 
         * @param {string} [resourceType] 
         * @param {string} [resourceId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled'} [status] 
         * @param {Date} [formedAtMin] 
         * @param {Date} [formedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'createdAt' | 'updatedAt' | 'formedAt' | 'number'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(number?: string, companyId?: string, responsibleId?: string, courseId?: string, courseTitle?: string, categoryId?: string, contractorId?: string, contractorType?: 'juridical' | 'physical', clientType?: string, clientId?: string, resourceType?: string, resourceId?: string, priceMin?: number, priceMax?: number, status?: 'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled', formedAtMin?: Date, formedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, sort?: 'createdAt' | 'updatedAt' | 'formedAt' | 'number', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
            return LearningRequestApiFp(configuration).list(number, companyId, responsibleId, courseId, courseTitle, categoryId, contractorId, contractorType, clientType, clientId, resourceType, resourceId, priceMin, priceMax, status, formedAtMin, formedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, sort, order, offset, limit, options)(axios, basePath);
        },
        /**
         * 
         * @summary Find learning requests short by filter.
         * @param {string} [number] 
         * @param {string} [companyId] 
         * @param {string} [responsibleId] 
         * @param {string} [courseId] 
         * @param {string} [courseTitle] 
         * @param {string} [categoryId] 
         * @param {string} [contractorId] 
         * @param {'juridical' | 'physical'} [contractorType] 
         * @param {string} [clientType] 
         * @param {string} [clientId] 
         * @param {string} [resourceType] 
         * @param {string} [resourceId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled'} [status] 
         * @param {Date} [formedAtMin] 
         * @param {Date} [formedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'createdAt' | 'updatedAt' | 'formedAt' | 'number'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShort(number?: string, companyId?: string, responsibleId?: string, courseId?: string, courseTitle?: string, categoryId?: string, contractorId?: string, contractorType?: 'juridical' | 'physical', clientType?: string, clientId?: string, resourceType?: string, resourceId?: string, priceMin?: number, priceMax?: number, status?: 'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled', formedAtMin?: Date, formedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, sort?: 'createdAt' | 'updatedAt' | 'formedAt' | 'number', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
            return LearningRequestApiFp(configuration).listShort(number, companyId, responsibleId, courseId, courseTitle, categoryId, contractorId, contractorType, clientType, clientId, resourceType, resourceId, priceMin, priceMax, status, formedAtMin, formedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, sort, order, offset, limit, options)(axios, basePath);
        },
    };
};

/**
 * LearningRequestApi - object-oriented interface
 * @export
 * @class LearningRequestApi
 * @extends {BaseAPI}
 */
export class LearningRequestApi extends BaseAPI {
    /**
     * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
     * @summary Delete learning request.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public _delete(id: string, options?: any) {
        return LearningRequestApiFp(this.configuration)._delete(id, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Change LearningRequest formedAt.
     * @param {string} id 
     * @param {InlineObject1} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public changeFormedAt(id: string, body?: InlineObject1, options?: any) {
        return LearningRequestApiFp(this.configuration).changeFormedAt(id, body, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Change LearningRequest startedAt.
     * @param {string} id 
     * @param {InlineObject2} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public changeStartedAt(id: string, body?: InlineObject2, options?: any) {
        return LearningRequestApiFp(this.configuration).changeStartedAt(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
     * @summary Change status of learning request.
     * @param {string} id 
     * @param {LearningRequestChangeStatus} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public changeStatus(id: string, body?: LearningRequestChangeStatus, options?: any) {
        return LearningRequestApiFp(this.configuration).changeStatus(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Get results of course lecture test.
     * @param {string} id 
     * @param {string} lectureId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public courseLectureTestResults(id: string, lectureId: string, options?: any) {
        return LearningRequestApiFp(this.configuration).courseLectureTestResults(id, lectureId, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Get results of course practice.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public coursePracticeResult(id: string, options?: any) {
        return LearningRequestApiFp(this.configuration).coursePracticeResult(id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.company_owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.responsible\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"learning_request.client\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">learningRequest</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Get results of course test.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public courseTestResults(id: string, options?: any) {
        return LearningRequestApiFp(this.configuration).courseTestResults(id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `company.owner` or `company.learning_request_manager`
     * @summary Create new learning request.
     * @param {LearningRequestCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public create(body?: LearningRequestCreate, options?: any) {
        return LearningRequestApiFp(this.configuration).create(body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
     * @summary Edit learning request.
     * @param {string} id 
     * @param {LearningRequestEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public edit(id: string, body?: LearningRequestEdit, options?: any) {
        return LearningRequestApiFp(this.configuration).edit(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`
     * @summary Get single learning request.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public get(id: string, options?: any) {
        return LearningRequestApiFp(this.configuration).get(id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible` or `learning_request.client`
     * @summary Get learning request statistic.
     * @param {string} companyId 
     * @param {string} [responsibleId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public getLearningRequestStatistic(companyId: string, responsibleId?: string, options?: any) {
        return LearningRequestApiFp(this.configuration).getLearningRequestStatistic(companyId, responsibleId, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `learning_request.company_owner` or `learning_request.responsible`
     * @summary Handle learning request.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public handle(id: string, options?: any) {
        return LearningRequestApiFp(this.configuration).handle(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Find learning requests to filter.
     * @param {string} [number] 
     * @param {string} [companyId] 
     * @param {string} [responsibleId] 
     * @param {string} [courseId] 
     * @param {string} [courseTitle] 
     * @param {string} [categoryId] 
     * @param {string} [contractorId] 
     * @param {'juridical' | 'physical'} [contractorType] 
     * @param {string} [clientType] 
     * @param {string} [clientId] 
     * @param {string} [resourceType] 
     * @param {string} [resourceId] 
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled'} [status] 
     * @param {Date} [formedAtMin] 
     * @param {Date} [formedAtMax] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {'createdAt' | 'updatedAt' | 'formedAt' | 'number'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public list(number?: string, companyId?: string, responsibleId?: string, courseId?: string, courseTitle?: string, categoryId?: string, contractorId?: string, contractorType?: 'juridical' | 'physical', clientType?: string, clientId?: string, resourceType?: string, resourceId?: string, priceMin?: number, priceMax?: number, status?: 'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled', formedAtMin?: Date, formedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, sort?: 'createdAt' | 'updatedAt' | 'formedAt' | 'number', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
        return LearningRequestApiFp(this.configuration).list(number, companyId, responsibleId, courseId, courseTitle, categoryId, contractorId, contractorType, clientType, clientId, resourceType, resourceId, priceMin, priceMax, status, formedAtMin, formedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, sort, order, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Find learning requests short by filter.
     * @param {string} [number] 
     * @param {string} [companyId] 
     * @param {string} [responsibleId] 
     * @param {string} [courseId] 
     * @param {string} [courseTitle] 
     * @param {string} [categoryId] 
     * @param {string} [contractorId] 
     * @param {'juridical' | 'physical'} [contractorType] 
     * @param {string} [clientType] 
     * @param {string} [clientId] 
     * @param {string} [resourceType] 
     * @param {string} [resourceId] 
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled'} [status] 
     * @param {Date} [formedAtMin] 
     * @param {Date} [formedAtMax] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {'createdAt' | 'updatedAt' | 'formedAt' | 'number'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningRequestApi
     */
    public listShort(number?: string, companyId?: string, responsibleId?: string, courseId?: string, courseTitle?: string, categoryId?: string, contractorId?: string, contractorType?: 'juridical' | 'physical', clientType?: string, clientId?: string, resourceType?: string, resourceId?: string, priceMin?: number, priceMax?: number, status?: 'not_processed' | 'waiting_payment' | 'learning' | 'learning_finished' | 'documents_ready' | 'completed' | 'cancelled', formedAtMin?: Date, formedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, sort?: 'createdAt' | 'updatedAt' | 'formedAt' | 'number', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
        return LearningRequestApiFp(this.configuration).listShort(number, companyId, responsibleId, courseId, courseTitle, categoryId, contractorId, contractorType, clientType, clientId, resourceType, resourceId, priceMin, priceMax, status, formedAtMin, formedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, sort, order, offset, limit, options)(this.axios, this.basePath);
    }

}
